import { render, staticRenderFns } from "./AdminEditKlass.vue?vue&type=template&id=689e71fc&scoped=true"
import script from "./AdminEditKlass.vue?vue&type=script&lang=js"
export * from "./AdminEditKlass.vue?vue&type=script&lang=js"
import style0 from "./AdminEditKlass.vue?vue&type=style&index=0&id=689e71fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e71fc",
  null
  
)

export default component.exports